import React from "react";
import { Tooltip, Popover } from "react-bootstrap";
import moment from "moment";
import "moment-timezone";
import Chip from "@material-ui/core/Chip";

export function tooltip(text) {
  return (
    <Tooltip id="tooltip">
      <strong>{text}</strong>
    </Tooltip>
  );
}

export function popover(text) {
  return (
    <Popover id="popover-top">
      <strong>{text}</strong>
    </Popover>
  );
}

export const format = "YYYY-MM-DD HH:mm:ss";
export const format_without_time = "YYYY-MM-DD";
export const format_display = "MM/DD/YYYY";
export const format_export = "DD/MM/YY";

export function getTimeInIST(dateString) {
  const timeInUTC = moment.utc(dateString, format);
  return timeInUTC.clone().tz("Asia/Kolkata");
}

export function currentTimeInIST() {
  return moment
    .utc()
    .clone()
    .tz("Asia/Kolkata");
}

export function toInt(n) {
  return parseInt(n, 10);
}

export function convertProjectStatusToString(status) {
  switch (status) {
    case "0":
      return "OnHold";
    case "1":
      return "In-Progress";
    case "2":
      return "Completed";
    default:
      return "None";
  }
}

export function getProjectStatusBadge(status) {
    let color = "#FFFFFF";
    switch (status) {
        case "0":
            color = "default";
            break;
        case "1":
            color = "primary";
            break;
        case "2":
            color = "secondary";
        break;
            default:
            color = "default";
        break;
    }

  return <Chip label={convertProjectStatusToString(status)} color={color} />;
}
